import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { MediaCategory } from '../../models/media/media-category.model';
import { SettingsService } from '../../services/settings.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { MediaCategoryNamesPopupComponent } from '../media-category-names-popup/media-category-names-popup.component';
import { MediaCategoryPopupComponent } from '../media-category-popup/media-category-popup.component';
import Swal from 'sweetalert2';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MediaCategoryDataSource } from './media-category-datasource';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-media-category',
  templateUrl: './media-category.component.html',
  styleUrls: ['./media-category.component.scss'],
})
export class MediaCategoryComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() public saleTemplateId: number;
  @Input() public showAddButton: boolean = false;
  @Input() public isSelectionMode: boolean = false;
  @Input() public isUseInternalSearch: boolean = true;
  @Input() public topPositionPx: number = 0;
  @Input() public set searchText(value: string) {
    this._searchText = value;
    if (this.dataSource) {
      this.applyFilter(value);
    }
  }
  public get searchText(): string {
    return this._searchText;
  }
  @Input() public defaultSelectedMediaCategoryIds?: number[] = null;
  @Output() public selectedIds = new EventEmitter<number[]>();
  public selectedIdsSet = new Set<number>();
  public dataSource: MediaCategoryDataSource;
  public originalData: MediaCategory[];
  private _searchText: string = '';
  //public selection = new SelectionModel<MediaCategory>(true, []);
  public isLoader: boolean;
  public closeResult = '';  
  public displayedColumns$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  private sortOrderSubject$ = new BehaviorSubject<'ASC' | 'DESC'>('ASC');
  @ViewChild("categorySort") sort: MatSort;
  @ViewChild('table1') dataTable: MatTable<any>;
  dragStartIndex: number | null = null;
  newLocation: number = null;
  modifiedData: any[] = [];
  isUpdated: boolean = false; // Track if changes have been made
  isSalesCompany: boolean = this.authService.IsSalesCompany();

  constructor(
    private readonly settings: SettingsService,
    private readonly modalService: NgbModal,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }
  get topClass(): string {
    return `th-top-${this.topPositionPx}`;
  }
  private getDisplayedColumns(): string[] {
    let columns = [
      'drag',
      'select',
      'mediaCategoryName',
      'shortName',
      'mediaGroup',
      'leftOrRight',
      'foreOrHind',
      'action',
      'moveup',
      'movedown',
    ];

    if (!this.showAddButton) {
      columns = columns.filter(col => !['drag', 'moveup', 'movedown'].includes(col));
    }

    return columns;
  }

  openMediaCategoryNamesPopup(category: MediaCategory) {
    const modalRef = this.modalService.open(MediaCategoryNamesPopupComponent, {
      ariaLabelledBy: category.id + 'Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = { category: category };
    modalRef.result.then(
      (result) => {
        //const data = JSON.parse(result);
        this.loadMediaCategories();
      },
      (reason) => {
        this.loadMediaCategories();
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  moveItem(event: MouseEvent, fromIndex: number, toIndex: number) {
    event.preventDefault();


    this.newLocation = toIndex;
    moveItemInArray(this.dataSource.data, fromIndex, toIndex);
    this.dataSource.data = [...this.dataSource.data];
    this.checkForChanges();
    this.dragStartIndex = null;
    this.dataTable.renderRows();
    //this.form.markAsDirty();
    this.cdr.detectChanges();
  }

  drop(event: CdkDragDrop<MediaCategory[]>) {
    this.newLocation = event.currentIndex;
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    this.dataSource.data = [...this.dataSource.data];
    this.checkForChanges();
    this.dragStartIndex = null;
    this.dataTable.renderRows();
   // this.form.markAsDirty();
    this.cdr.detectChanges();
  }
  // Update the modifiedData and enable the update button
  // Compare the current order with the original order
  checkForChanges() {
    const hasChanged = this.dataSource.data.some((item, index) =>
      item.id !== this.originalData[index].id
    );

    if (hasChanged) {
      this.modifiedData = this.dataSource.data.map((item, index) => ({
        mediaCategoryId: item.id,
        sortOrder: index + 1, // Update sort order
      }));
    } else {
      this.modifiedData = [];
    }

    this.isUpdated = hasChanged; // Enable button only if order changed
  }

  // Call this when update button is clicked
  updateTable() {
    if (this.modifiedData.length === 0) return; // Prevent unnecessary API calls

    this.settings
      .SaveMediaCategorySorting(this.modifiedData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isLoader = false;
        this.dataSource = new MediaCategoryDataSource(response, this.sort);
        this.originalData = [...response];
        this.isUpdated = false;
      });
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  deleteMediaCategory(category: MediaCategory) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Delete',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoader = true;
        this.settings
          .deleteMediaCategoryById(category.id)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((response) => {
            this.toastService.success('Category Removed!', 'Categories');
            this.loadMediaCategories();
          });
      }
    });
  }
  downloadMediaCategory(){
    
    this.settings.downloadMediaCategorycsv().subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'mediacategory.csv';
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
  openMediaCategoryPopup(category: MediaCategory) {
    const modalRef = this.modalService.open(MediaCategoryPopupComponent, {
      ariaLabelledBy: category?.id + 'Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = { category: category };
    modalRef.result.then(
      (result) => {
        //const data = JSON.parse(result);
        this.loadMediaCategories();
      },
      (reason) => {
        this.loadMediaCategories();
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  
  public isAllSelected(): boolean {
    const numSelected = this.selectedIdsSet.size;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public IsDisableSend(): boolean {
    const numSelected = this.selectedIdsSet.size;
    return !(numSelected > 0);
  }
  masterToggle($event: MatCheckboxChange): void {
    const isChecked = $event.checked;
    this.dataSource.data.forEach(row => {
      row.isSelected = isChecked;
    });
    this.dataSource.filteredData.forEach(row => {
      row.isSelected = isChecked;
    });
    this.onCheckboxChange();
  }


  emitOutput() {
    const selected = Array.from(this.selectedIdsSet);
    this.selectedIds.emit(selected);
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public loadMediaCategories(): void {
    this.isLoader = true;
    this.settings
      .getMediaCategories(this.saleTemplateId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {

        if (this.defaultSelectedMediaCategoryIds?.length) {
          response.forEach(row => {
            row.isSelected = this.defaultSelectedMediaCategoryIds.includes(row.id);
          });
        }

        this.selectedIdsSet = new Set(
          response.filter(row => row.isSelected).map(row => row.id)
        );
        
        this.dataSource = new MediaCategoryDataSource(response, this.sort);
        this.originalData = [...response];
        this.emitOutput();
        const value = this.searchText;
        if (value) {
          this.applyFilter(value);
        }
        this.isLoader = false;
      });
  }

  ngOnInit(): void {
    this.displayedColumns$.next(this.getDisplayedColumns());
    this.dataSource = new MediaCategoryDataSource([], this.sort);
    this.loadMediaCategories();
  }

  public sortTable(sortBy: keyof MediaCategory): void {
    const currentOrder = this.sortOrderSubject$.value;
    this.sortOrderSubject$.next(currentOrder === 'ASC' ? 'DESC' : 'ASC');
    this.compare(sortBy);
  }

  private compare(keySorted: keyof MediaCategory): void {
    const categories = this.dataSource.data;

    categories.sort((a, b) =>
      this.sortOrderSubject$.value === 'ASC'
        ? this.sortValuesByName(a, b, keySorted)
        : this.sortValuesByName(b, a, keySorted) // Reverse order for DESC
    );

    this.dataSource.data = categories; // Update the data source
  }

  private sortValuesByName(
    a: MediaCategory,
    b: MediaCategory,
    keySorted: keyof MediaCategory
  ): number {
    const aValue = a[keySorted] || '';
    const bValue = b[keySorted] || '';

    return aValue.toString().localeCompare(bValue.toString(), navigator.languages[0] || navigator.language, {
      numeric: true,
      ignorePunctuation: true,
    });
  }

  onCheckboxChange(): void {
    if (this.dataSource.filter) {
      const filtered = this.dataSource.filteredData;

      // Step 1: Build a map of isSelected states from filteredData
      const selectionMap = new Map<number, boolean>();
      filtered.forEach(row => selectionMap.set(row.id, row.isSelected));

      // Step 2: Apply selection state to full data list
      this.dataSource.data.forEach(row => {
        if (selectionMap.has(row.id)) {
          row.isSelected = selectionMap.get(row.id)!;
        }
      });
    }

    // Step 3: Update selectedIdsSet from updated full data
    const selected = this.dataSource.data
      .filter(row => row.isSelected)
      .map(row => row.id);

    this.selectedIdsSet = new Set(selected);
    this.emitOutput();
  }

  applyFilter(filterValue: string): void {
    this._searchText = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
